import _extends from "@babel/runtime/helpers/extends";
import { Box, SkeletonCircle, SkeletonGroup, SkeletonRectangle, Text } from '@wix/design-system';
import React, { useCallback, useMemo } from 'react';
import { CollapseListItem } from '../collapse-list-item';
export const TaskListItem = /*#__PURE__*/React.memo(_ref => {
  let {
    title,
    prefix,
    suffix,
    isLoading = false,
    disabled = false,
    children,
    showTopShadow = true,
    showBottomShadow = true,
    showArrowIcon = true,
    ...rest
  } = _ref;
  const hasTitleValue = useMemo(() => {
    if (title === undefined || title === null) {
      return false;
    }
    if (typeof title === 'string') {
      return title.trim().length > 0;
    }
    return true;
  }, [title]);
  const renderPrefix = useCallback(() => {
    if (isLoading) {
      if (hasTitleValue) {
        return /*#__PURE__*/React.createElement(Box, {
          padding: "2px"
        }, /*#__PURE__*/React.createElement(SkeletonCircle, {
          diameter: "14px"
        }));
      }
      return null;
    }
    return prefix;
  }, [hasTitleValue, isLoading, prefix]);
  const renderTitle = useCallback(() => {
    if (isLoading && !hasTitleValue) {
      return /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(Box, {
        direction: "horizontal",
        gap: "SP1",
        verticalAlign: "middle"
      }, /*#__PURE__*/React.createElement(Box, {
        padding: "2px"
      }, /*#__PURE__*/React.createElement(SkeletonCircle, {
        diameter: "14px"
      })), /*#__PURE__*/React.createElement(SkeletonRectangle, {
        height: "12px",
        width: "120px"
      })));
    }
    return typeof title === 'string' ? /*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "normal"
    }, title) : title;
  }, [hasTitleValue, isLoading, title]);
  const renderSuffix = useCallback(() => {
    if (isLoading) {
      return null;
    }
    return suffix;
  }, [isLoading, suffix]);
  return /*#__PURE__*/React.createElement(CollapseListItem, _extends({
    disabled: disabled || isLoading,
    prefix: renderPrefix(),
    showArrowIcon: showArrowIcon,
    showBottomShadow: showBottomShadow,
    showContentDivider: false,
    showTopShadow: showTopShadow,
    suffix: renderSuffix(),
    title: renderTitle()
  }, rest), children);
});
//# sourceMappingURL=task-collapse-list-item.js.map